import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { formatCourseLevel } from '../../../../utils/courseLevel';

const NO_FILL = { fill: 'none' };

const CourseCardHead = ({ image, title, programName, programId }) => {
  const navigate = useNavigate();
  const level = formatCourseLevel(programName);

  const openProgram = () => {
    localStorage.setItem('programId', JSON.stringify(programId));
    navigate('/course/program');
  };

  const content = (
    <>
      {image && <img className="course-card__flag" src={image} alt="" width="1" height="1" decoding="async" />}
      <span className="course-card__names">
        <span className="course-card__title">{title}</span>
        {level && <span className="course-card__level">{level}</span>}
      </span>
    </>
  );

  if (!programId) {
    return <div className="course-card__head">{content}</div>;
  }

  return (
    <button type="button" className="course-card__head course-card__head--link" onClick={openProgram}>
      {content}
      <span className="course-card__go" aria-hidden="true">
        <svg className="course-card__go-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 5.5 15.5 12 9 18.5" style={NO_FILL} />
        </svg>
      </span>
    </button>
  );
};

CourseCardHead.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  programName: PropTypes.string,
  programId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CourseCardHead.defaultProps = {
  image: '',
  title: '',
  programName: '',
  programId: null,
};

export default CourseCardHead;
